export default "__VITE_ASSET__B$11zyk9__"